import React from 'react'
import { RouteProps } from 'react-router-dom'

import { useSuccessTemplateProps } from '../../../templates/Success/useProps'
import SuccessTemplate from '../../../templates/Success'

const SuccessPage: React.FC<RouteProps> = () => {
  const templateProps = useSuccessTemplateProps()

  return <SuccessTemplate {...templateProps} />
}

export default SuccessPage
